module.exports = __webpack_public_path__ + "img/pro_detail_3.2b2273e6.jpg";